// API URL utility to handle both development and production environments
export const getApiUrl = (): string => {
  // In production, use relative path so nginx proxy works
  // This works for both HTTP and HTTPS without needing port configuration
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    
    // Check if we're on Vite dev server (port 5173)
    if (window.location.port === '5173') {
      // Dev server - backend is on port 3000 of same host
      return `${protocol}//${hostname}:3000/api`;
    }
    
    // In production, use relative path
    // This lets nginx handle the proxying regardless of protocol or port
    return '/api';
  }
  
  // Fallback for SSR or other environments
  return '/api';
};